import { useEffect } from 'react';

const BASE_TITLE = 'CCAI - Chinese Community AI';

export default function usePageTitle(pageTitle) {
  useEffect(() => {
    document.title = pageTitle ? `${pageTitle} | ${BASE_TITLE}` : BASE_TITLE;
    return () => { document.title = BASE_TITLE; };
  }, [pageTitle]);
}
